"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ApproveAs = require("./ApproveAs/ApproveAs");
Object.keys(_ApproveAs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ApproveAs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ApproveAs[key];
    }
  });
});
var _Camera = require("./Camera/Camera");
Object.keys(_Camera).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Camera[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Camera[key];
    }
  });
});
var _Deny = require("./Deny/Deny");
Object.keys(_Deny).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Deny[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Deny[key];
    }
  });
});
var _Microphone = require("./Microphone/Microphone");
Object.keys(_Microphone).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Microphone[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Microphone[key];
    }
  });
});